<ion-content [scrollY]="false">
  @if (state.inProgressActivityId) {
    @if (state.isNewQuestionLayoutEnabled) {
      <dojo-question
        (completed)="handleCompletedQuestion($event)"
        [isTransitioningBetweenQuestions]="state.isTransitioningBetweenQuestions"
      />
    } @else {
      <dojo-question-old (completed)="handleCompletedQuestion($event)" />
    }
  } @else {
    @if (state.isLoading) {
      <dojo-loader class="flex h-full items-center justify-center" />
    } @else {
      @if (state.ongoingActivityId && state.candidates; as candidates) {
        <dojo-question-selection
          @appearDisappear
          [questionCandidates]="candidates"
          (candidateSelected)="handleCandidateSelected($event)"
          (cancelled)="handleCompletedQuestion('stop')"
        />
      }
    }
  }
</ion-content>
